export default __webpack_public_path__ + "static/media/eye.3f439071.svg";